import { UID } from 'react-uid';
import React, { useState, useEffect } from 'react';

import Theme from '../../Theme';
import XIcon from '../../SVG/XIcon';

import StyledPopover from './styles';

const { scaleDown01 } = Theme.scale;
const { colorGrayBlue50 } = Theme.color;

const Popover = ({ children, tip, shouldPop }) => {
  const [isVisible, setVisibility] = useState(shouldPop);

  useEffect(() => setVisibility(shouldPop), [shouldPop]);
  return (
    <UID>
      {(uid) => (
        <StyledPopover>
          {children && (
            <span aria-describedby={`popover-${uid}`}>{children}</span>
          )}
          <div id={`popover-${uid}`} role="tooltip" aria-hidden={!isVisible}>
            <div onMouseDown={(e) => e.stopPropagation()} role="presentation">
              {tip}
              <button
                type="button"
                className="dismiss"
                title="dismiss"
                onClick={() => setVisibility(false)}
              >
                <XIcon size={scaleDown01} color={colorGrayBlue50} />
              </button>
            </div>
          </div>
        </StyledPopover>
      )}
    </UID>
  );
};

Popover.defaultProps = {
  shouldPop: false,
};

export default Popover;
